"use strict";
var ubian = ubian || {};

/**
 * SEO handling
 */
ubian.seo = {
  skipFirstCallConnection: true,
  skipFirstCallStops: true,
  /**
   *
   * @param {string} url url to force in addressbar
   * @param {*} seoKey prefix from seo.lang.yml file (without .Title, .H1 or .Desc)
   * @param {*} params additional parameters for translation
   */
  setState: function (url, seoKey, params) {
    if (__ubian_branding == 'DPMK') {
      return;
    }
    if (!seoKey) {
      seoKey = "Navigation.Main";
    }
    seoKey = "SEO." + seoKey;
    var title = ubian.translate(seoKey + ".Title", params || {});
    if (!url) {
      url = "/";
    }
    if (window.location.hash) {
      url += window.location.hash;
    }
    window.history.replaceState({}, title, url);
    document.title = title + " | Ubian.sk";
  },
  /**
   * set url and title from getConnectionFilterState() in search-connection module
   * @param {object} currentState
   */
  setStateFromSearchConnection: function (currentState) {
    if (__ubian_branding == 'DPMK') {
      return;
    }
    if (ubian.seo.skipFirstCallConnection) {
      ubian.seo.skipFirstCallConnection = false;
      return;
    }
    mapping = { bus: "autobusy", train: "vlaky", urban: "mhd" };
    var url = "/";
    var seoKey = "";
    var params = {};
    if (currentState.filter.indexOf(",") == -1) {
      url = "/cp-" + mapping[currentState.filter];
      seoKey = "Navigation.Connection." + currentState.filter.ucFirst();
      if (currentState.filter != "urban") {
        this.setState(url, seoKey, params);
      }
      if (
        currentState.filter == "urban" &&
        currentState.city &&
        typeof ubian_nav.urbanCitiesList[currentState.city] != "undefined"
      ) {
        url = "/mhd-" + ubian_nav.urbanCitiesList[currentState.city].slug;
        seoKey = "Navigation.Connection.UrbanCity";
        params = { ":city": ubian_nav.urbanCitiesList[currentState.city].name };
        this.setState(url, seoKey, params);
      }
    }
  },
  /**
   * set url and title from getStopsFilterState() in search-stops module
   * @param {*} currentState
   */
  setStateFromSearchStops: function (currentState) {
    if (__ubian_branding == 'DPMK') {
      return;
    }
    if (ubian.seo.skipFirstCallStops) {
      ubian.seo.skipFirstCallStops = false;
      return;
    }
    mapping = { bus: "autobusov", train: "vlakov", urban: "mhd" };
    var url = "/";
    var seoKey = "";
    var params = {};
    if (
      currentState.filter.indexOf(",") == -1 &&
      currentState.filter != "urban"
    ) {
      url = "/odchody-" + mapping[currentState.filter];
      seoKey = "Navigation.Stops." + currentState.filter.ucFirst();

      if (window.location.href.indexOf(url) == -1) {
        this.setState(url, seoKey, params);
      }
    }
  },
};
